<template>
  <div class="input">
    <input
      ref="input"
      type="text"
      :disabled="disabled"
      :placeholder="placeholder"
      @input="keyupInput($event)"
      v-on="$listeners"
      :value="text"
      @blur="handleBlur($event)"
      v-select.focus
      v-focus
    />
  </div>
</template>

<script>
export default {
  props: ["placeholder", "text", "disabled"],
  methods: {
    mounted: function() {
      this.$nextTick(function() {
        // Code that will run only after the
        // entire view has been rendered
        this.$refs.input.focus();
        this.$refs.input.select();
      });
    },
    keyupInput(e) {
      this.$emit("input", e);
    },
    handleBlur(e) {
      this.$emit("blur", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.input input {
  font-size: 12px;
  // border-radius: 0;
  color: #000;
}
.input input::placeholder {
  font-size: 12px !important;
  color: #000 !important;
}
</style>
